import { render, staticRenderFns } from "./FormatInput.vue?vue&type=template&id=52f604f6&scoped=true"
import script from "./FormatInput.vue?vue&type=script&lang=js"
export * from "./FormatInput.vue?vue&type=script&lang=js"
import style0 from "./FormatInput.vue?vue&type=style&index=0&id=52f604f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f604f6",
  null
  
)

export default component.exports